import { render } from "./SingleSentenceInput.vue?vue&type=template&id=3448d29c"
import script from "./SingleSentenceInput.vue?vue&type=script&lang=js"
export * from "./SingleSentenceInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__